<div class="stmnt_footer_right">
  <div class="data_row no_padding compact text_right">
    <div class="data_label">Total</div>
    <div class="data_value large_text">
      $ {{ currentTotal | number: "1.2-2":"en-US" }}
    </div>
  </div>
</div>

